import {createStorageManager} from '@sollapay/utils';
import {useState} from 'react';

export type SidebarMode = 'expanded' | 'collapsed';

const storage = createStorageManager({prefix: 'sollapay'});

function isSidebarMode(value: unknown): value is SidebarMode {
  return value === 'expanded' || value === 'collapsed';
}

export function useSidebarModePreference(
  storageKey: string,
  defaultMode: SidebarMode = 'expanded'
) {
  const [mode, setMode] = useState<SidebarMode>(() => {
    const stored = storage.getItem(storageKey);
    return stored !== null && isSidebarMode(stored) ? stored : defaultMode;
  });

  return {
    mode,
    setPreferredMode: (newMode: SidebarMode) => {
      setMode(newMode);
      storage.setItem(storageKey, newMode);
    }
  };
}
